import React from 'react';

export const DEFAULT_PAGE_SIZE = 25;

const Pagination = ({ nPages, currentPage, setCurrentPage, pageSize, setPageSize, totalItems }) => {
  if (nPages <= 0) return null;

  const pageNumbers = [...Array(nPages + 1).keys()].slice(1);
  const maxPageNumbersToShow = 5;

  const goToNextPage  = (e) => { e.preventDefault(); if (currentPage < nPages) setCurrentPage(currentPage + 1); };
  const goToPrevPage  = (e) => { e.preventDefault(); if (currentPage > 1)      setCurrentPage(currentPage - 1); };
  const goToFirstPage = (e) => { e.preventDefault(); setCurrentPage(1); };
  const goToLastPage  = (e) => { e.preventDefault(); setCurrentPage(nPages); };

  let start = Math.max(currentPage - Math.floor(maxPageNumbersToShow / 2), 1);
  let end   = Math.min(start + maxPageNumbersToShow - 1, nPages);
  if (end === nPages) start = Math.max(nPages - maxPageNumbersToShow + 1, 1);
  const pagesToShow = pageNumbers.slice(start - 1, end);

  const perPage     = pageSize || DEFAULT_PAGE_SIZE;
  const showingFrom = totalItems != null ? Math.min((currentPage - 1) * perPage + 1, totalItems) : null;
  const showingTo   = totalItems != null ? Math.min(currentPage * perPage, totalItems) : null;

  return (
    <div className="ce-pagination">
      <span className="ce-pagination-info">
        {totalItems != null
          ? <>Showing <strong>{showingFrom}–{showingTo}</strong> of <strong>{totalItems}</strong></>
          : <>&nbsp;</>}
      </span>

      <div className="ce-pagination-controls">
        <button className="page-btn" onClick={goToFirstPage} disabled={currentPage === 1}      title="First">«</button>
        <button className="page-btn" onClick={goToPrevPage}  disabled={currentPage === 1}      title="Previous">‹</button>
        {start > 1 && <span style={{ color: 'var(--bs-secondary-color)', fontSize: '0.75rem' }}>…</span>}
        {pagesToShow.map(pg => (
          <button
            key={pg}
            className={`page-btn${currentPage === pg ? ' active' : ''}`}
            onClick={e => { e.preventDefault(); setCurrentPage(pg); }}
          >
            {pg}
          </button>
        ))}
        {end < nPages && <span style={{ color: 'var(--bs-secondary-color)', fontSize: '0.75rem' }}>…</span>}
        <button className="page-btn" onClick={goToNextPage}  disabled={currentPage === nPages} title="Next">›</button>
        <button className="page-btn" onClick={goToLastPage}  disabled={currentPage === nPages} title="Last">»</button>
      </div>

      {setPageSize && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          <span style={{ fontSize: '0.75rem', color: 'var(--bs-secondary-color)' }}>Per page:</span>
          {[10, 25, 50, 100].map(size => (
            <button
              key={size}
              className={`page-btn${pageSize === size ? ' active' : ''}`}
              onClick={() => setPageSize(size)}
            >
              {size}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Pagination;
